import { ColumnDef } from '@tanstack/react-table';
import { FieldArrayWithId, UseFieldArrayRemove } from 'react-hook-form';
import StyledTable from '@/components/styled/StyledTable';
import { PATHS } from '@/constants/Paths';
import type { AssociatedBenefitRow } from '@/types/benefits/hotelAssociatedBenefitColumnDef';
import { HotelFormDataWithTranslations } from '@/i18n/translation-type-utils';

type AssociatedBenefitField = FieldArrayWithId<
  HotelFormDataWithTranslations,
  'associatedBenefits'
>;

interface AssociatedBenefitsTableProps {
  fields: AssociatedBenefitField[];
  remove: UseFieldArrayRemove;
  isViewMode: boolean;
  columns: ColumnDef<AssociatedBenefitRow>[];
}

const AssociatedBenefitsTable = ({
  fields,
  remove,
  isViewMode,
  columns,
}: AssociatedBenefitsTableProps) => {
  const data = fields.map((field, index) => ({
    id: field.id,
    index,
    benefitId: field.benefitId,
    frequency: field.frequency,
    benefit: field.benefit,
  }));

  return (
    <div className="border rounded-md overflow-auto">
      <StyledTable
        columns={columns}
        data={data}
        getRowId={(row) => row.id}
        onDeleteRow={
          isViewMode ? undefined : (row) => remove(row.original.index)
        }
        onViewRow={(row) => {
          const id = row.original.benefit?.id;
          if (id) {
            window.open(
              PATHS.home.benefits.activity.view.replace(':benefitId', id),
              '_blank',
            );
          }
        }}
        enablePagination={false}
      />
    </div>
  );
};

export default AssociatedBenefitsTable;
